import api from '@/api';
import type { components } from '@/api/qraft/schema';

type CourseStudyAccess = components['schemas']['CourseStudyAccess'];

/**
 * Whether the viewer may open this student's Course Study tab, which of the two
 * first-slot screens they get, and whether they may award a certificate.
 *
 * Legacy picks the subnav's first item by RELATIONSHIP — assigned study helper,
 * follow-up coordinator or partner, one of the student's group coordinators, or
 * an administrator gets Course Progression; otherwise, if viewer == displayed,
 * Courses (`themes/wbs/modules/student-course-study/class-course-study.php:28-49`).
 * The viewer's own profile type decides nothing, which is why nothing on this tab
 * may branch on `useCurrentUser().isStudent` / `.isStudyHelper`.
 *
 * One hook so the shell, the index route and the certificates route share a
 * single cached answer: same operation and same parameters is the same query key.
 */
export function useCourseStudyAccess(memberId: string | number): {
  access: CourseStudyAccess | undefined;
  isLoading: boolean;
} {
  const studentId = Number(memberId);
  const { data: access, isLoading } = api.getCourseStudyAccess.useQuery(
    { path: { student_id: studentId } },
    { enabled: Number.isInteger(studentId) && studentId > 0 },
  );

  return { access, isLoading };
}
